import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {fragments}      from "@Common/react/fragments";
import {Invoke}         from "@Common/react/invoke";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";

export const UserAssetsLayoutLoader = ({next}) => cs(

    consumeContext("apis"),
    ["agentId", (_, next) => UseState({next})],
    ["agent", ({apis, agentId}, next) => Load2({
        _key: agentId.value,
        keepOutdatedValue: true,
        fetch: () => !agentId.value ? null : apis.next.session.getAgent({agentId: agentId.value}),
        next,
    })],
    ["user", ({apis, agent}, next) => {
        const idUser = agent.value?.idUser;
        return Load2({
            _key: idUser,
            fetch: () => !idUser ? null : apis.next.userProfile.getUserProfile(idUser),
            next,
        });
    }],
    ({agent, user, agentId}) => React.createElement(
        LayoutLoaderContext.Provider,
        {
            value: {
                loadHeaderData: ({agentId: agentId1, next}) => fragments(
                    agentId1 !== agentId.value && Invoke({
                        action: () => agentId.onChange(agentId1),
                    }),

                    next({
                        loading: agent.loading || agent.value == null || user.loading,
                        agent: agent.value,
                        user: user.value,
                        reload: async () => (
                            await Promise.all([
                                agent.reload(),
                                user.reload(),
                            ])
                        ),
                        clear: () => agentId.onChange(null),
                    }),
                )
            },
        },
        next(),
    ),
);

export const LayoutLoaderContext = React.createContext(null);
